var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoRecord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-record 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-record"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M27.3334 30.6667V26.6667C27.3334 23.7333 29.7334 21.3333 32.6667 21.3333C35.6001 21.3333 38.0001 23.7333 38.0001 26.6667V30.6667M46.0001 56H19.3334C13.4667 56 8.66675 51.2 8.66675 45.3333V18.6667C8.66675 12.8 13.4667 8 19.3334 8H46.0001C51.8667 8 56.6667 12.8 56.6667 18.6667V45.3333C56.6667 51.2 51.8667 56 46.0001 56ZM38.5334 42.6667H26.8001C25.2001 42.6667 24.1334 41.6 24.1334 40V33.3333C24.1334 31.7333 25.2001 30.6667 26.8001 30.6667H38.8001C40.4001 30.6667 41.4667 31.7333 41.4667 33.3333V40C41.2001 41.6 40.1334 42.6667 38.5334 42.6667Z",
    stroke: "#D1D5DB",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoRecord);
export default __webpack_public_path__ + "static/media/icon-no-record.f2d3633726853acb2e1771417fa06b58.svg";
export { ForwardRef as ReactComponent };